import * as yup from "yup";

const newsBroadcastValidator = yup
  .object({
    title: yup.string().required("Title is required"),
    to: yup.string().required("To is required"),
    driver_age: yup
      .array()
      .of(yup.number())
      .when("to", (to, schema) => {
        if (to.length > 0 && to[0] === "drivers")
          return schema.length(2).required("Driver age is required");
        return schema;
      }),
    fleet_production_year: yup
      .array()
      .of(yup.number())
      .when("to", (to, schema) => {
        if (to.length > 0 && to[0] === "drivers")
          return schema.length(2).required("Fleet production year is required");
        return schema;
      }),
    fleet_category: yup.string().optional(),
    content: yup.string().required("Content is required"),
  })
  .required();

export default newsBroadcastValidator;
